import toolsClient from "@/api/toolsClient";

const getStatus = async (id) => {
  const { data } = await toolsClient.get(`stations/${id}/audioads`);

  return data;
};

const updateStatus = async (id, status, applyToRelays = null) => {
  applyToRelays =
    applyToRelays !== null ? "?applyToRelays=" + !!applyToRelays : "";

  const { data } = await toolsClient.put(
    `stations/${id}/audioads/${status}` + applyToRelays
  );

  return data;
};

export default {
  getStatus,
  updateStatus,
};
